import BlockStages from '@/components/blocks/Admin/Stages/BlockStages';
import SuperAdminGuard from '@/services/RouteGuards/SuperAdmin';

export default [
	{
		path: 'stages',
		name: 'Stages',
		component: BlockStages,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Stages - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	}
];
